// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { LoadableAfterPaint } from '@confluence/loadable';
import { fg } from '@confluence/feature-gating';

export const KeyboardShortcutsDialog = LoadableAfterPaint<any>({
	loader: async () => {
		if (fg('confluence_frontend_new_keyboard_shortcut_dialog')) {
			return (
				await import(
					/* webpackChunkName: "loadable-KeyboardShortcutsDialog" */ './NewKeyboardShortcutsDialog.tsx'
				)
			).KeyboardShortcutsDialog;
		} else {
			return (
				await import(
					/* webpackChunkName: "loadable-KeyboardShortcutsDialog" */ './KeyboardShortcutsDialog.tsx'
				)
			).KeyboardShortcutsDialog;
		}
	},
});
